import React from 'react';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditIcon from '@material-ui/icons/Edit';

import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { IContextRowReadonlyProps } from './context-selector.types';
import { RowGrid } from './context-selector.styles';

// A locked row: kind label + selection chips, editable again via the pencil or
// removable via the trash. Flag styling (stale / misfit) carries over.
export const ContextRowReadonly: React.FC<IContextRowReadonlyProps> = ({
  typeMessage,
  chips,
  helper,
  onEdit,
  onRemove
}) => (
  <RowGrid>
    <Typography variant="body2" color="textSecondary" className="context-row-type">
      <IntlMsg {...typeMessage} />
    </Typography>
    <Box className="context-row-chips" display="flex" flexWrap="wrap" gridGap={4} alignItems="center">
      {chips.map((chip) => (
        <Chip
          key={chip.key}
          size="small"
          label={chip.label}
          className={chip.flagged ? 'context-chip-misfit' : undefined}
          title={chip.flagged ? chip.flagTitle : undefined}
        />
      ))}
      {helper}
    </Box>
    <IconButton size="small" aria-label="Edit context" onClick={onEdit}>
      <EditIcon fontSize="small" />
    </IconButton>
    <IconButton size="small" aria-label="Remove context" onClick={onRemove}>
      <DeleteOutlineIcon fontSize="small" />
    </IconButton>
  </RowGrid>
);
